import { SubPartnerAccount, withStyles } from 'vopay';
import { DetailsCard, DetailRow } from 'UI';
import { useTranslation } from 'react-i18next';
import styles from './Details.module.scss';

const cn = withStyles(styles);

type DetailsProps = {
  partner: SubPartnerAccount;
};

export default function Details({ partner }: DetailsProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Partners.Details' });

  return (
    <div className={cn('detailsContent')}>
      <div className={cn('section')}>
        <div className={cn('sectionTitle')}>{t('businessDetails', { defaultValue: 'Business Details' })}</div>
        <DetailsCard>
          <DetailRow label={t('legalBusinessName', { defaultValue: 'Legal Business Name' })} value={partner.Name} />
          <DetailRow
            label={t('partnerAccountId', { defaultValue: 'Partner Account ID' })}
            value={partner.PartnerAccountID}
          />
          <DetailRow label={t('country', { defaultValue: 'Country' })} value={partner.Country || '-'} />
          <DetailRow label={t('emailAddress', { defaultValue: 'Email Address' })} value={partner.EmailAddress || '-'} />
        </DetailsCard>
      </div>
    </div>
  );
}
